export const useDrawerState = (key: string) => {
  const visible = useState(key, () => false)

  function open() {
    visible.value = true
  }
  function close() {
    visible.value = false
  }
  function toggle() {
    visible.value = !visible.value
  }

  return {
    open,
    close,
    toggle,
    visible,
  }
}
